import { Button, ButtonProps } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { buildProjectsByTagSearchPath } from '../../../utils/projectTags'

type ProjectTagButtonProps = {
    tag: string
} & Pick<ButtonProps, 'sx' | 'size' | 'variant' | 'color'>

export const ProjectTagButton = ({
    tag,
    sx,
    variant = 'contained',
    color = 'secondary',
    size,
}: ProjectTagButtonProps) => {
    const navigate = useNavigate()

    return (
        <Button
            type="button"
            variant={variant}
            color={color}
            size={size}
            sx={sx}
            onClick={() => navigate(buildProjectsByTagSearchPath(tag))}
        >
            {tag}
        </Button>
    )
}
